import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	displayText: {
		id: 'software.main.header.menu.edit-sprint-item.display-text',
		defaultMessage: 'Edit sprint',
		description: 'Dropdown menu item which opens up edit sprint modal to allow user to edit sprint',
	},
});
